<template>
    <div>
        <div>
            <div class="imageModal" v-if="imgCover" style="position: fixed; z-index: 999; background-color: rgba(0,0,0, .7); right:0; top: 0">
                <span class="close" @click='imgCover = ""' style="cursor: pointer; font-size:35px; margin:8px; ">&times;</span>
                <img style="position: fixed; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%); width: 450px;  " v-bind:src="imgCover" alt="Alternate Text" />

            </div>

        </div>
        <b-card bg-variant="Light" class="p-3">
            <div>
                <b-card-text>
                    <div class="row">
                        <div style="width: 12%; padding-left: 15px;">
                            <div v-if="RequestSource == 'search'" @click="ShowDetailPage(ElasticData._source.productReference)">
                                <b-img-lazy ref="searchImgRef" id="searchImg" center fluid blank blank-src="/images/loading_eclipse.gif" :src="CheckImageUrl(ElasticData._source.coverUrl, ElasticData._source.productReference, ElasticData._source.datasourceID)"
                                            width="130" height="170" style="float: left; border: 1px solid #bbb; cursor: pointer;">
                                </b-img-lazy>
                            </div>

                            <div v-if="RequestSource == 'details'" @click="imgViewer">
                                <b-img-lazy ref="detailImgRef" id="detailsImg" center fluid blank blank-src="/images/loading_eclipse.gif" :src="CheckImageUrl(ElasticData._source.coverUrl, ElasticData._source.productReference, ElasticData._source.datasourceID)"
                                            width="130" height="170" style="float: left; border: 1px solid #bbb; cursor: pointer;">
                                </b-img-lazy>
                            </div>

                        </div>
                        <div style="width: 66%; margin-left:1%">
                            <div v-if="ElasticData._source.contributors && ElasticData._source.contributors.length > 0 && RequestSource == 'details'">

                                <div v-if="ElasticData._source.contributors && ElasticData._source.contributors.length > 0 && RequestSource == 'details'">
                                    <div class="contributors-section">
                                        <a  v-for="contributor in ElasticData._source.contributors" :key="index" :href="generateItemLink(contributor.contributorName, 'contributors')" class="filter-link">{{contributor.keyNames}}</a>
                                    </div>
                                </div>
                            </div>
                            <p class="ElasticData_Author" style="margin-bottom:0.2rem !important;" v-if="ElasticData._source.contributorStatement && ElasticData._source.contributorStatement !='-' && RequestSource == 'search'">{{Decodehtml(ElasticData._source.contributorStatement)}}</p>
                            <span v-if="!ElasticData._source.contributorStatement" v-for="(contributor, index) in contributors">
                                <span class="ElasticData_Author" v-if="contributor.keyNames !='-'">{{contributor.keyNames}}</span>
                                <span v-if="index+1 < contributors.length">,</span>
                            </span>
                            <p style="margin-bottom:0.2rem !important;" id="distinctiveTitle"><a class="Main_Title" @click="ShowDetailPage(ElasticData._source.productReference)">{{Decodehtml(ElasticData._source.distinctiveTitle)}}</a></p>
                            <p style="font-size: 13px; font-style: italic; text-align: left !important; margin-bottom: 0.2rem !important">{{ElasticData._source.subtitle}}</p>

                            <p v-if="isJournal()" style="margin-bottom: 0.2rem !important">
                                <label v-if="ElasticData._source.volumeYear">{{translationKeywords.volume}}:</label>{{ElasticData._source.volumeYear}}
                                <span v-if="ElasticData._source.volumeYear && ElasticData._source.publicationFrequency">, </span>
                                <span v-if="ElasticData._source.publicationFrequency">{{ElasticData._source.publicationFrequency}}</span>
                                <span v-else>{{ElasticData._source.editionStatement}}</span>
                            </p>
                            <p v-else style="margin-bottom: 0.2rem !important">{{ElasticData._source.editionStatement}}</p>
                            <div>
                                <div v-if="ElasticData._source.publishers">
                                    <div class="d-flex justify-center">
                                        <a v-for="publisher in ElasticData._source.publishers" :key="index" :href="generateItemLink(publisher, 'publisher')" class="filter-link">{{publisher}}</a>
                                    </div>
                                </div>
                            </div>

                            <!--<p style="margin-bottom: 0.2rem !important" v-if="ElasticData._source.cityOfPublication">{{ElasticData._source.cityOfPublication}}<span v-if="ElasticData._source.countryOfPublication">, {{ElasticData._source.countryOfPublication}}</span></p>-->
                            <p v-if="ElasticData._source.publicationYear <= 2300 && ElasticData._source.publicationYear >= 1000 && ElasticData._source.availability_Text == 'Available'" style="margin-bottom: 0.2rem !important">{{translationKeywords.publicationDate}}: {{ElasticData._source.publicationDateDisplay}}</p>
                            <p v-if="(ElasticData._source.availability=='derzeit nicht lieferbar' || ElasticData._source.availability=='Will be orderable') && ElasticData._source.expectedShipDate" style="margin-bottom: 0.2rem !important">{{translationKeywords.expectedShipDate}}: {{ElasticData._source.expectedShipDate}}</p>
                            <p style="margin-bottom: 0.2rem !important">
                                <span v-show="ElasticData._source.mediaType == 'Journal'">{{translationKeywords.journal}}</span>
                                <span v-show="ElasticData._source.mediaType != 'Journal'">{{ElasticData._source.productForm}}</span>

                                <span v-if="ElasticData._source.productFormDetail && ElasticData._source.productFormDetail.length > 0 && ElasticData._source.productFormDetail[0]" style="margin-left:-3px;">
                                    ,&nbsp;{{ElasticData._source.productFormDetail[0]}},
                                </span>
                                <span v-if="ElasticData._source.productFormDescription && (ElasticData._source.productFormDetail && ElasticData._source.productFormDetail.length>0 && !ElasticData._source.productFormDetail[0])" style="margin-left:-3px;">
                                    ,&nbsp;{{ElasticData._source.productFormDescription}},
                                </span>

                                <span v-if="ElasticData._source.epubType" style="margin-left: -3px;">,&nbsp;{{ElasticData._source.epubType}}</span>
                                <span v-show="ElasticData._source.pages!=null" style=" margin-left: -3px;">,&nbsp;{{ElasticData._source.pages}} {{translationKeywords.pages}},</span>
                                <span v-show="ElasticData._source.duration!=null" style=" margin-left: -3px;">&nbsp;{{translationKeywords.duration}}: {{ElasticData._source.duration}},</span>
                                <span v-show="ElasticData._source.fileSize!=null" style=" margin-left: -3px;">&nbsp;{{translationKeywords.filesize}}: {{ElasticData._source.fileSize}},</span>
                                <span v-if="ElasticData._source.publicationLanguages" v-for="(lang, index) in ElasticData._source.publicationLanguages">
                                    {{lang}}
                                    <span v-if="index >= 0 && index < ElasticData._source.publicationLanguages.length - 1" style=" margin-left: -3px;">, </span>
                                </span>
                                <span v-show="ElasticData._source.isbN13Hyphens==null && !ElasticData._source.mediaType">{{ElasticData._source.productReference}}</span>
                                <span v-show="ElasticData._source.mediaType !=null && isJournal()">, {{ElasticData._source.issn}}</span>
                                <span v-show="!ElasticData._source.mediaType">{{ElasticData._source.isbN13Hyphens}}</span>
                            </p>



                            <p v-if="ElasticData._source.productReference" style="margin-bottom: 0.2rem !important">{{ElasticData._source.productReference}}</p>

                            <!--<b-button size="sm" class="mb-2"  @click="downloadPdf(ElasticData._source.productReference)">
        <b-icon icon="file-earmark-pdf" style=" color:#fff;" aria-hidden="true"></b-icon>
        Download Pdf
    </b-button>-->
                            <!--<i  class="fa fa-file-pdf-o mb-2 mt-1 pdf-icon" style="font-size:25px"  @click="downloadPdf(ElasticData._source.productReference)"></i>-->

                            <div v-show="ShowRelated" style="padding-top: 15px;">
                                <table>
                                    <tr v-for="relatedProduct in relatedProducts">
                                        <td style="text-align:left" v-if="relatedProduct.isbN13">
                                            <span style="font-size: 13px; font-style: italic;">
                                                {{relatedProduct.relationCode}}
                                            </span>
                                        </td>
                                        <td style="text-align:left">
                                            <a @click="RelatedProductSearch(relatedProduct.isbN13)" class="relatedProduct"> {{relatedProduct.isbN13}}</a>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div v-if="ElasticData._source.numberOfPieces" class="mt-3">
                                <b class="mb-1 d-inline-block">{{translationKeywords.NumberOfPieces}} {{ElasticData._source.numberOfPieces}}</b>
                                <div v-for="product in ElasticData._source.relatedProducts">
                                    <b>{{product.productForm}}</b>: <span>{{product.productReference}}</span>
                                </div>
                            </div>
                         
                            <!--<i v-if="pdfDownload" class="fa fa-file-pdf-o mb-2 mt-2 pdf-icon" style="font-size:25px" @click="downloadPdf(ElasticData._source.productReference)"></i>-->
                            <div v-if="pdfDownload" class="pdf-button p-0" :title="translationKeywords.exportPdf">
                                <i class="fa fa-file-pdf-o mb-2 mt-2 pdf-icon" style="font-size:25px" @click="downloadPdf(ElasticData._source.productReference)"></i>
                            </div>
                            <b-modal ref="my-modal" hide-footer hide-header no-close-on-esc no-close-on-backdrop centered size="md">

                                <div v-if="downloading">
                                    <span style="font-weight:500; font-size:18px;">{{translationKeywords.Downloading}} </span>&nbsp;
                                    <img height="25" width="25" src="/Images/icons8-download.gif" />
                                </div>
                                <div v-if="succeded">
                                    <i class="dx-icon-check dx-icon-custom-style"></i>
                                    <span style="font-weight:500; font-size:18px;">{{translationKeywords.PdfDownloadedSuccessfully}} </span> &nbsp;

                                </div>
                                <div v-if="pdfError">
                                    <i class="dx-icon-remove dx-icon-custom-style"></i>
                                    <span style="font-weight:500; font-size:18px;">{{translationKeywords.downloadFailed}}</span> &nbsp;

                                </div>
                            </b-modal>

                        </div>
                        <div style="width:20%;text-align:right;">
                            <div :id="`${ElasticData._source.productReference}_price`" v-if="!ShowJournalPrices || !isJournal()">
                                <span v-if="ElasticData._source.price && ElasticData._source.price.priceDescription">
                                    <b-img src="/Images/info-icon.svg" style="margin-top: -10px;width: 25px;" v-b-tooltip.hover
                                           :title="ElasticData._source.price.priceDescription">
                                    </b-img>
                                </span>
                                <div class="price-options-container">
                                    <div v-if="!ElasticData._source.unpricedItemType" class="price-option">
                                        <span class="ElasticData_Price">
                                            <div class="price-title">{{getPriceTypeDesc()}}</div>
                                            <div class="price-amount">

                                                <div v-if="!ElasticData._source.hasCustomCalculatedPrice">

                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount ">{{ElasticData._source.finalPrice.priceAmount + " " + ElasticData._source.finalPrice.currency}} </span>
                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount " class="price-type">
                                                        <span v-if="ElasticData._source.isExecludingTaxPrice">(Preis vom Lieferanten)</span>
                                                        <span v-else>(inkl. MwSt.)</span>
                                                    </span>
                                                    <span v-if="isJournal()">{{showJournalPrice()}}</span>
                                                    <span v-if="isJournal()" class="price-type">
                                                        <span v-if="ElasticData._source.isExecludingTaxPrice">(Preis vom Lieferanten)</span>
                                                        <span v-else>(inkl. MwSt.)</span>
                                                    </span>
                                                </div>

                                                <div v-else-if="ElasticData._source.hasCustomCalculatedPrice">
                                                    <span class="price-amount-discount" v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount "><span>{{ElasticData._source.finalPrice.orginal_PriceAmount + " " + ElasticData._source.finalPrice.currency}} </span></span>
                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount " class="price-type price-type-discount">
                                                        <span v-if="ElasticData._source.isExecludingTaxPrice">(Preis vom Lieferanten)</span>
                                                        <span v-else>(inkl. MwSt.)</span>
                                                    </span>
                                                    <p class="mb-0 mt-2 price-discount-text">Our exclusive price for you *</p>
                                                    <span class="price-amount" v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount "><span>{{ElasticData._source.finalPrice.priceAmount + " " + ElasticData._source.finalPrice.currency}} </span></span>
                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount " class="price-type">
                                                        <span v-if="ElasticData._source.isExecludingTaxPrice">(Preis vom Lieferanten)</span>
                                                        <span v-else>(inkl. MwSt.)</span>
                                                    </span>


                                                </div>


                                                <div v-else>
                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount "><s>{{formatCurrency(ElasticData._source.finalPrice.priceAmount)}}</s> </span>
                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount " class="price-type">
                                                        <s>
                                                            <span v-if="ElasticData._source.isExecludingTaxPrice">(Preis vom Lieferanten)</span>
                                                            <span v-else>(inkl. MwSt.)</span>
                                                        </s>
                                                    </span><br /><br />
                                                    <span class="label">{{translationKeywords.calculatedPriceLabel}}<span style="cursor:pointer" :title="translationKeywords.calculatedPriceTitle"> *</span></span><br />
                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount ">{{ElasticData._source.calculatedPrice.formattedPrice + " " + ElasticData._source.finalPrice.currency}} </span>
                                                    <span v-if="!isJournal() && ElasticData._source.finalPrice && ElasticData._source.finalPrice.priceAmount " class="price-type">
                                                        <span v-if="ElasticData._source.isExecludingTaxPrice">(Preis vom Lieferanten)</span>
                                                        <span v-else>(inkl. MwSt.)</span>
                                                    </span>
                                                    <span v-if="isJournal()">{{showJournalPrice()}}</span>
                                                    <span v-if="isJournal()" class="price-type">
                                                        <span v-if="ElasticData._source.isExecludingTaxPrice">(Preis vom Lieferanten)</span>
                                                        <span v-else>(inkl. MwSt.)</span>
                                                    </span>
                                                </div>



                                            </div>
                                            <span style="color:red;cursor:pointer" v-if="ElasticData._source.finalPrice.converted" :title="translationKeywords.convertedPrice"> *</span>
                                        </span>
                                        <div class="price-description" v-if="isJournal()">
                                            {{showPriceDescription()}}
                                        </div>
                                        <a class="more-prices" @click="ShowDetailPage(ElasticData._source.productReference)" v-if="isJournal() && ElasticData._source.prices.length >1 ">Weitere Preise anzeigen</a>
                                    </div>
                                    <div v-else>
                                        <span>{{MapUnpricedItemTypeCode(ElasticData._source.unpricedItemType)}}</span>
                                    </div>
                                </div>
                            </div>




                            <div :id="`${ElasticData._source.productReference}_price`" v-if="ShowJournalPrices && isJournal()">
                                <!-----------price options in product details page ----------------------------->
                                <div class="price-options-container radio product-details">
                                    <div class="price-option radio" v-for="(item, index) in ElasticData._source.prices">
                                        <div class="price-title">{{getPriceTypeDesc(item.priceTypeCode)}}</div>
                                        <label><input type="radio" name="optradio" :checked="index==0" :value="item" @change="onSelectedPriceChanged($event,item)">{{showJournalPrice(item)}}</label>
                                        <div class="price-description">
                                            {{showPriceDescription(item)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <p style="margin-bottom: 4px;">
                                <span style="float: right; margin-left: 5px; text-align: right;" v-if="ElasticData._source.availability">{{ElasticData._source.availability}}</span>
                                <span :id="'availability-' + ElasticData._source.productReference" :class="ElasticData._source.availability_Text"></span>
                            </p>
                            <br />
                            <!-- Buttons -->
                            <p>
                                <div class="item-btns">
                                    <span v-show="ShowShoppingCartStatus">{{ElasticData._source.item_inShoppingCart}}</span>

                                    <img src="/Images/cart-icon.jpg" :id="ElasticData._source.productReference" class="cart-img pb-1" v-if="ItemInShoppingCart" />

                                    <b-spinner variant="" label="Text Centered" :id="'ShoppingCartLoader-'+ElasticData._source.productReference" v-if="AddToShoopingCart" class="cart-loader"></b-spinner>

                                    <oDB-form :ElasticData="ElasticData" v-if=" ElasticData._source.availability_Text!=='NotAvailable' &  isODB() & isAuthorized" :mode="'ODB'"></oDB-form>
                                    <oDB-form :ElasticData="ElasticData" v-if="CheckIsPriceless() && !isODB()" :mode="'Priceless'"></oDB-form>
                                    <input :ElasticData="ElasticData" class="test-access-btn w-100"
                                           v-if=" ElasticData._source.availability_Text!=='NotAvailable' && !isAuthorized &&  isODB()"
                                           :mode="'ODB'" :data-isbn="ElasticData._source.productReference" 
                                           type="button" value="Bestellung" />
                            
                            <input type="button" class="first-btn w-100" :id="'btnShoppingCart-'+ElasticData._source.productReference"
                                   style=" margin-bottom: 5px;" :value="translationKeywords.addShoppingCart"
                                   @click="AddToShoppingCart(ElasticData._source.productReference,ElasticData._source.availability_Text)"
                                   v-if="displayAddTocart() && !CheckIsPriceless()" />

                            <input type="button" class="first-btn w-100" :id="'btnShoppingCart-'+ElasticData._source.productReference"
                                   style=" margin-bottom: 5px;" :value="translationKeywords.goToCart"
                                   @click="goToCart()"
                                   v-if="isJournal() && isAddedToCart()" />

                            <input type="button" class="first-btn w-100"
                                   style=" margin-bottom: 5px;" :value="translationKeywords.goToDetailPage"
                                   @click="ShowDetailPage(ElasticData._source.productReference)"
                                   v-if="isJournal() && !ShowJournalPrices" />
                            <br v-if="!isODB() && !isJournal() && !CheckIsPriceless()" />
                            <slot name="wishlistButton"></slot>
                            <slot name="DeleteButton"></slot>
                        </div>
                            </p>

                            <p>

                                <img :src="GetLibraryStatus(ElasticData._source.libraryStatus.itemLibrary_Status)" width="24" style="float: right; margin-top: -7px;" :title="ElasticData._source.libraryStatus.itemLibrary_ToolTip" />
                            </p>
                        </div>
                    </div>
                </b-card-text>
            </div>
        </b-card>
    </div>
</template>
<script>
    import config from "../../config/config.js";
    import { BButton } from 'bootstrap-vue';
    import { BIcon } from 'bootstrap-vue';
    import { setTimeout } from "timers";
    import { generateLink } from "@/common/custom.js";
    import ResourceHelper from "@common/globalization/ResourceHelper";
    import ODBForm from "./ODB-Form.vue";
    import popover from "@/components/PopOver.vue";
    import { format } from 'url';
    import DxButton from 'devextreme-vue/button';
    import { debug } from "util";
    Vue.component('b-button', BButton);
    Vue.component('b-icon', BIcon);
    //Sort function
    function compare(a, b) {
        if (a.sequenceNumber < b.sequenceNumber) {
            return -1;
        }
        if (a.sequenceNumber > b.sequenceNumber) {
            return 1;
        }
        return 0;
    }
    export default {
        name: 'elastic-search-ElasticData',
        components: {
            DxButton
        },

        props: ['addedToCart', 'ElasticData', 'ShowRelated', 'ShowJournalPrices', 'RequestSource', 'ShowShoppingCartStatus'],
        data() {
            return {
                pdfBodyData: {
                    PortalImage: '',
                    CoverURL: ''
                },
                authToken:null,
                pdfDownload: config.PdfDownload,
                downloading: false,
                succeded: false,
                pdfError: false,
                isAuthorized:false,
                translationKeywords: {
                    downloadFailed: '',
                    exportPdf: '',
                    PdfDownloadedSuccessfully: '',
                    Downloading: '',
                    clearAggregations: '',
                    resultPerPage: '',
                    sortBy: '',
                    journal: '',
                    noResult: '',
                    addShoppingCart: '',
                    goToDetailPage: '',
                    goToCart: '',
                    addToWishList: '',
                    searchTerm: '',
                    back: '',
                    convertedPrice: '',
                    publicationDate: '',
                    volume: '',
                    calculatedPriceTitle: '',
                    calculatedPriceLabel: '',
                    unPricedItemTypeCode1: '',
                    unPricedItemTypeCode2: '',
                    unPricedItemTypeCode3: '',
                    unPricedItemTypeCode4: '',
                    unPricedItemTypeCode5: '',
                    unPricedItemTypeCode6: '',
                    expectedShipDate: '',
                    NumberOfPieces: '',
                    pages: '',
                    minutes: '',
                    filesize: '',
                    duration: ''
                },
                generateItemLink: generateLink,
                productReference: '',
                priceRelevent: null,
                priorityPrices: [
                    'RRPIncludingTax',
                    'RRPExcludingTax',
                    'SuppliersAlternativeNetPriceExcludingTax',
                    'SpecialSaleRRPExcludingTax'
                ],
                PriceTypeCodeNames: [
                    "RRPExcludingTax",
                    "RRPIncludingTax",
                    "FixedRetailPriceExcludingTax",
                    "FixedRetailPriceIncludingTax",
                    "SuppliersNetPriceExcludingTax",
                    "SuppliersNetPriceExcludingTaxRentalGoods",
                    "SuppliersNetPriceIncludingTax",
                    "SuppliersAlternativeNetPriceExcludingTax",
                    "SuppliersAlternativeNetPriceIncludingTax",
                    "SpecialSaleRRPExcludingTax",
                    "SpecialSaleRRPIncludingTax",
                    "SpecialSaleFixedRetailPriceExcludingTax",
                ],
                ItemInShoppingCart: false,
                AddToShoopingCart: false,
                pricesChecked: null,
                imgCover: '',
                isHidden: false,
                toggle: true,
            }
        },
        methods: {
            hideModal() {
                this.$refs['my-modal'].hide();
            },
            GetCodeList(name) {
                if (name == 16) return "ISNI";
                if(name == 25) return "GND";
                return null;
            },
            downloadPdf: function (item) {

                let searchImage = this.$refs.searchImgRef;
                let detailImage = this.$refs.detailImgRef;
                //if (this.pdfBodyData.PortalImage === "https://bookseller.mynewbooks.biz/Portals/_demoportal/images/logo-libri-biz.jpg") {
                //    this.pdfBodyData.PortalImage = "https://bookseller.mynewbooks.biz/Portals/_demoportal/images/logo-libri-biz2.jpg";
                //}
                //console.log(this.pdfBodyData.PortalImage)
                this.pdfBodyData.CoverURL = this.$refs.searchImgRef ? this.$refs.searchImgRef.src : this.$refs.detailImgRef.src;
                const portalElement = document.getElementById('ctl04_Banner_Image1');
                const portalImageElement = portalElement.src;

                //const portalsSrcValue = portalImageElement.getAttribute('src');
                console.log(portalImageElement)
                this.pdfBodyData.PortalImage = portalImageElement;
                this.$refs['my-modal'].show();
                this.downloading = true;
                var SearchUrl = getSearchUrl();
                var reftothis = this;
                axios({
                    method: 'post',
                    url: SearchUrl + '/download/title/detailspdf/' + item,
                    data: this.pdfBodyData,
                    headers: {
                        "portal-id": getCookie("PortalId"),
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher"),

                    },
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                    const link = document.createElement('a');
                    link.href = url;

                    link.setAttribute('download', item + '.pdf');
                    link.click();

                    if (response.status === 200) {

                        this.downloading = false;
                        this.succeded = true;
                        setTimeout(() => this.$refs['my-modal'].hide(), 3000);
                    }

                }).catch(err => {

                    this.downloading = false;
                    this.succeded = false;
                    this.pdfError = true;
                    setTimeout(() => this.$refs['my-modal'].hide(), 3000);
                });
                this.succeded = false;
            },
            imgViewer: function (e) {
                this.imgCover = e.target.getAttribute("src");

            },
            formatCurrency: function (amount, culture, currency) {
                culture = getCookie("Esperantus_Language_languageSwitcher");
                if (!culture)
                    culture = "de-DE";

                if (!currency)
                    currency = "EUR";

                if (typeof amount == 'string' && amount.includes(','))
                    amount = amount.replace(',', '.');

                if (culture.length == 2)
                    culture += "-" + culture.toUpperCase();

                let formatter = new Intl.NumberFormat(
                    culture, { style: 'currency', currency: currency, currencyDisplay: 'code', minimumFractionDigits: 2 }
                );
                return formatter.format(amount);
            },

            MapUnpricedItemTypeCode: function (code) {
                if (code == '01')
                    return this.translationKeywords.unPricedItemTypeCode1;
                if (code == '02')
                    return this.translationKeywords.unPricedItemTypeCode2;
                if (code == '03')
                    return this.translationKeywords.unPricedItemTypeCode3;
                if (code == '04')
                    return this.translationKeywords.unPricedItemTypeCode4;
                if (code == '05')
                    return this.translationKeywords.unPricedItemTypeCode5;
                if (code == '06')
                    return this.translationKeywords.unPricedItemTypeCode6;
            },
            CheckIsPriceless: function () {
                return !(
                    this.ElasticData._source.price &&
                    this.ElasticData._source.price.active &&
                    !(typeof (this.ElasticData._source.price.priceAmount) == 'string' && this.ElasticData._source.price.priceAmount.stratsWith("-")) &&
                    !(typeof (this.ElasticData._source.price.priceAmount) == 'string' && this.ElasticData._source.price.priceAmount.stratsWith("0")) &&
                    (typeof (this.ElasticData._source.price.priceAmount) == 'number' && this.ElasticData._source.price.priceAmount > 0)
                )
            },
            CheckImageUrl: function (imageURL, ISBN, supplier) {                
                return GetImage(ISBN, supplier, imageURL);
                //if (!config.GraphQlEnabled)
                //    return GetImage(ISBN, supplier, imageURL);
                //else
                //    return imageURL != 'https://covers.datahub.newbooks.de' ? imageURL : '/images/Empty_Cover.png';
            },
            onSelectedPriceChanged: function (e, selectedItem) {
                if (e.currentTarget.checked) {
                    this.pricesChecked = selectedItem;
                }
            },
            ShowDetailPage: function (productReference) {
                if (!this.ShowRelated) {
                    sessionStorage.SearchUrl = document.URL;
                    this.$emit('ShowDetailPage', productReference);
                }
            },
            GetLibraryStatus: function (status) {
                if (Boolean(status)) {
                    return "/Images/home-green.png";
                }
                else {
                    return "/Images/home-black.png";
                }
            },
            showPrice(price) {
                if (price)
                    return this.getPriceFormat(price);
                return this.getPriceFormat(this.priceRelevent);
            },
            showJournalPrice(price) {
                if (price)
                    return this.formatJournalsPrice(price);
                return this.formatJournalsPrice(this.priceRelevent);
            },
            showPriceDescription(price) {

                if (!price) price = this.priceRelevent;
                var description = [];
                if (price.priceDescription)
                    description.push(price.priceDescription);
                if (price.discountPercent)
                    description.push("Versandkosten " + formatMoney(price.discountPercent) + " EUR");

                if (price.discountCoded && price.discountCoded[0]) {
                    if (price.discountCoded[0].discountCode)
                        description.push("Printanteil " + formatMoney(price.discountCoded[0].discountCode) + " EUR");
                    if (price.discountCoded[0].discountCodeTypeName)
                        description.push("Onlineanteil " + formatMoney(price.discountCoded[0].discountCodeTypeName) + " EUR");
                }
                return description.join(', ');
            },
            getPriceTypeDesc(priceTypeCode) {
                if (!priceTypeCode)
                    priceTypeCode = this.priceRelevent.priceTypeCode;
                if (Number.isInteger(priceTypeCode))
                    priceTypeCode = this.PriceTypeCodeNames[priceTypeCode];
                return ResourceHelper.getString(priceTypeCode);
            },
            getPriceFormat(price) {
                return formatMoney(price.priceAmount) + ' ' + price.currency;
            },
            formatJournalsPrice(price) {
                let culture = getCookie("Esperantus_Language_languageSwitcher");
                return formatCurrency(price.priceAmount, culture, price.currency);
            },
            goToCart() {
                //var portalUrl = window.location.origin;
                var cartUrl = "";

                let name = "cartUrl=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        cartUrl = c.substring(name.length, c.length);
                    }
                }

                window.open(cartUrl, "_self")
                //window.location.reload();
            },
            AddToShoppingCart(ProductReference, Availability) {
                var bodyFormData = new FormData();
                bodyFormData.append('productReference', ProductReference);
                bodyFormData.append('RequestSource', this.requestSource());

                var refToThis = this;
                if (Availability !== "NotAvailable") {
                    var ShoppingCartHandlerUrl = AddToShoppingCartHandlerUrl();
                    refToThis.AddToShoopingCart = true;
                    if (refToThis.isJournal()) {
                        //this.pricesChecked;
                        bodyFormData.append('PriceChecked', JSON.stringify(this.pricesChecked));
                    }

                    axios({
                        method: 'POST',
                        data: bodyFormData,
                        headers: { 'Content-Type': 'multipart/form-data' },
                        url: ShoppingCartHandlerUrl,
                        headers: {
                            "portal-culture": getCookie("Esperantus_Language_languageSwitcher")
                        }
                    }).then(function (result) {
                        if (result.status === 200) {
                            var ShoppingCartElasticDatasCount = $("#ShoppingCartItemsCount").text();
                            if (parseInt(ShoppingCartElasticDatasCount) !== "NaN") {
                                ShoppingCartElasticDatasCount++;
                                $("#ShoppingCartItemsCount").text(ShoppingCartElasticDatasCount);
                                refToThis.AddToShoopingCart = false;
                                refToThis.ItemInShoppingCart = true;
                                refToThis.addedToCart = true;
                            }
                        }
                        else {
                            refToThis.AddToShoopingCart = false;
                        }
                    });
                }
                else {
                    var btnShoppingCartId = 'btnShoppingCart-' + ProductReference;
                    $("#" + btnShoppingCartId).prop('value', 'Artikel ist nicht lieferbar');
                    alert('Artikel ist nicht lieferbar');
                }
            },
            isODB: function () {
                return (
                    this.ElasticData._source.productForm == 'Online resource' || this.ElasticData._source.productForm == 'Online-Datei')
                    && GetODB_Flag(); //disable ;
            },

            isJournal() {
                return this.ElasticData._source.mediaType == 14 || this.ElasticData._source.mediaType == 'Journal';
            },
            isAddedToCart() {
                return this.addedToCart;
            },
            RelatedProductSearch: function (item) {
                var getSearchUrl = getCookie("searchUrl");
                var CurrentUrl = window.location.origin + getSearchUrl;
                window.history.pushState({ path: CurrentUrl }, ''
                    , CurrentUrl + '?Id=' + item);
                window.location.reload();
            },
            translation: function () {
                var dt = new Date();
                var formattedDate = " " + dt.getDate() + "." + (dt.getMonth() + 1) + "." + dt.getFullYear();
                this.translationKeywords.clearAggregations = ResourceHelper.getString("clearAggregations");
                this.translationKeywords.resultPerPage = ResourceHelper.getString("resultPerPage");
                this.translationKeywords.sortBy = ResourceHelper.getString("sortBy");
                this.translationKeywords.journal = ResourceHelper.getString("journal");
                this.translationKeywords.noResult = ResourceHelper.getString("noResult");
                this.translationKeywords.addShoppingCart = ResourceHelper.getString("addShoppingCart");
                this.translationKeywords.goToDetailPage = ResourceHelper.getString("goToDetailPage");
                this.translationKeywords.goToCart = ResourceHelper.getString("goToCart");
                this.translationKeywords.addToWishList = ResourceHelper.getString("addToWishList");
                this.translationKeywords.searchTerm = ResourceHelper.getString("searchTerm");
                this.translationKeywords.back = ResourceHelper.getString("back");
                this.translationKeywords.convertedPrice = ResourceHelper.getString("convertedPrice") + formattedDate;
                this.translationKeywords.publicationDate = ResourceHelper.getString("publicationDate");
                this.translationKeywords.volume = ResourceHelper.getString("volume");
                this.translationKeywords.calculatedPriceLabel = ResourceHelper.getString("calculatedPriceLabel");
                this.translationKeywords.calculatedPriceTitle = ResourceHelper.getString("calculatedPriceTitle");
                this.translationKeywords.unPricedItemTypeCode1 = ResourceHelper.getString("unPricedItemTypeCode1");
                this.translationKeywords.unPricedItemTypeCode2 = ResourceHelper.getString("unPricedItemTypeCode2");
                this.translationKeywords.unPricedItemTypeCode3 = ResourceHelper.getString("unPricedItemTypeCode3");
                this.translationKeywords.unPricedItemTypeCode4 = ResourceHelper.getString("unPricedItemTypeCode4");
                this.translationKeywords.unPricedItemTypeCode5 = ResourceHelper.getString("unPricedItemTypeCode5");
                this.translationKeywords.unPricedItemTypeCode6 = ResourceHelper.getString("unPricedItemTypeCode6");
                this.translationKeywords.expectedShipDate = ResourceHelper.getString("expectedShipDate");
                this.translationKeywords.NumberOfPieces = ResourceHelper.getString("NumberOfPieces");
                this.translationKeywords.PdfDownloadedSuccessfully = ResourceHelper.getString("PdfDownloadedSuccessfully");
                this.translationKeywords.Downloading = ResourceHelper.getString("Downloading");
                this.translationKeywords.exportPdf = ResourceHelper.getString("exportPdf");
                this.translationKeywords.downloadFailed = ResourceHelper.getString("downloadFailed");
                this.translationKeywords.pages = ResourceHelper.getString("pages");
                this.translationKeywords.minutes = ResourceHelper.getString("minutes");
                this.translationKeywords.duration = ResourceHelper.getString("duration");
                this.translationKeywords.filesize = ResourceHelper.getString("filesize");
            },
            Decodehtml: function (value) {
                var decodedString = "";
                if (value) {
                    var parser = new DOMParser;
                    var dom = parser.parseFromString(value.replace(/(?:\r\n|\r|\n)/g, ''), 'text/html');
                    decodedString = dom.body.textContent;
                    decodedString = decodedString.replace(/<[^>]*>?/gm, '');
                }

                return decodedString;
            },
            selectReleventPrice() {
                if (this.isJournal() && this.ElasticData._source.prices != null) {
                    for (var j = 0; j < this.priorityPrices.length; j++) {
                        for (var i = 0; i < this.ElasticData._source.prices.length; i++) {
                            if (this.ElasticData._source.prices[i].priceTypeCode == this.priorityPrices[j]) {

                                this.priceRelevent = this.ElasticData._source.prices[i];
                                //    return this.getPriceFormat(product.prices[i]);
                                return;
                            }
                        }
                    }
                    if (this.ElasticData._source.prices.length > 0) {
                        this.priceRelevent = this.ElasticData._source.prices[0];
                        return;

                    }

                }
                this.priceRelevent = this.ElasticData._source.finalPrice;
                return;
            },
            displayAddTocart: function () {

                return !(this.isJournal() && this.isAddedToCart())
                    && this.ElasticData._source.availability_Text !== 'NotAvailable'
                    && !this.isODB()
                    && (!this.isJournal() || this.ShowJournalPrices)
                    && this.ElasticData._source.finalPrice
                    && (this.ElasticData._source.finalPrice.priceAmount || this.ElasticData._source.finalPrice.orginal_PriceAmount)

            },
            requestSource: function () {
                return this.RequestSource ? this.RequestSource : "search";
            },
            filterContributors: function () {
                if (this.ElasticData._source.contributors) {
                    let filteredData = this.ElasticData._source.contributors.filter((item) => item.contributorRole == 'ByAuthor' || item.contributorRole == 'EditedBy ' || item.contributorRole == 'FoundedBy');
                    this.ElasticData._source.contributors = filteredData.sort(compare).slice(0, 3);
                }
            }
        },
        computed: {
            relatedProducts: function () {
                if (this.ElasticData._source.relatedProducts) {
                    var RelatedProducts = this.ElasticData._source.relatedProducts;
                    var RelatedProductsObj = [];
                    if (RelatedProducts.length > 0) {
                        for (var i = 0; i < RelatedProducts.length; i++) {
                            if (RelatedProducts[i].relationCode.trim() != 'Unspecified') {
                                RelatedProductsObj.push(RelatedProducts[i]);
                            }
                        }
                    }
                }
                return RelatedProductsObj;
            },
            Contributors: function () {
                var ContributorList = this.ElasticData._source.contributors;
                if (ContributorList == null) {
                    return [];
                }
            }
        },
        created: function () {
            this.translation();
            this.selectReleventPrice();
            this.pricesChecked = this.ElasticData._source.prices != null && this.ElasticData._source.prices.length > 0
                ? this.ElasticData._source.prices[0] : null;
            this.filterContributors();
        },
        components: {
            popover, ODBForm
        },
        mounted() {
            this.id = this._uid;
            let authorizationToken = getCookie("ApiToken");
            this.authToken = authorizationToken || null ;
            if (this.authToken !== '' && this.authToken !== null) {
                this.isAuthorized = true;
            } else {
                this.isAuthorized = false;
            }

        }
    }
</script>
<style>
    .Main_Title {
        font-size: 18px;
        color: #414751;
        font-weight: bold;
        line-height: 22px;
    }

    .ElasticData_ID {
        font-size: 14px;
    }

    .ElasticData_Publisher {
        font-size: 15px;
    }

    .ElasticData_Author {
        color: #414751 !important;
        font-size: 13px;
        font-weight: bold;
    }

    .ElasticData_Price {
        color: #cb060b;
        font-size: 18px;
        font-style: normal;
        font-weight: bold;
    }

    .card {
        border: none !important;
        border-bottom: 1px solid #e5e5e5 !important;
    }

    p.card-text {
        margin-bottom: 0.5rem !important;
    }

    .cart-img {
        width: 30px;
        position: relative;
        top: -2px
    }

    .cart-loader {
        width: 32px;
    }

    /* Green Circle */
    .Available {
        height: 12px;
        width: 12px;
        background-color: #90c153;
        border-radius: 50%;
        display: inline-block;
        margin-left: 95px;
        margin-top: 5px;
        float: right;
    }

    /* Red Circle */
    .NotAvailable {
        height: 12px;
        width: 12px;
        background-color: #f52d00;
        border-radius: 50%;
        display: inline-block;
        margin-left: 95px;
        margin-top: 5px;
        float: right;
    }

    /* Orange Circle */
    .WillBeOrderable {
        height: 12px;
        width: 12px;
        background-color: #fcb23f;
        border-radius: 50%;
        display: inline-block;
        margin-left: 95px;
        margin-top: 5px;
        margin-bottom: 10px;
        float: right;
    }


    .imageModal {
        width: 100vw !important;
        height: 100% !important;
    }

    .close {
        padding: 10px 24px;
    }

    .pdf-icon {
        font-size: 25px;
        cursor: pointer !important;
    }

    .dx-icon-check {
        font-size: 21px;
        background-color: #57ab31;
        color: #fff;
        padding: 9px;
        border-radius: 50%;
        margin-right: 10px;
    }

    .dx-icon-remove {
        font-size: 21px;
        background-color: #B61F29;
        color: #fff;
        padding: 9px;
        border-radius: 50%;
        margin-right: 10px;
    }
    .price-type-discount, span.price-amount-discount {
        text-decoration: line-through;
    }
    .price-discount-text {
        font-family: 'Open Sans', sans-serif;
        color: #727777;
        font-weight: bold;
        text-indent: 2px;
    }
</style>
